module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "chap-title paracenter",
    staticStyle: {
      "font-size": "2em!important",
      "margin-top": "4em!important",
      "margin-bottom": "3em!important"
    }
  }, [_c('b', [_vm._v("Contents")])])]), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/09_acknowledgement#ack",
      "id": "ack"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/10_prologue#pro",
      "id": "pro"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/11_chapter1#ch1",
      "id": "ch1"
    }
  }, [_vm._v("The Funeral")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/12_chapter2#ch2",
      "id": "ch2"
    }
  }, [_vm._v("Georgi Markov, London, September 1978")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/13_chapter3#ch3",
      "id": "ch3"
    }
  }, [_vm._v("The KGB’s Poison Factory")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/14_chapter4#ch4",
      "id": "ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Those were the days")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/15_chapter5#ch5",
      "id": "ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Litvinenko: Operation "), _c('span', {
    staticClass: "small"
  }, [_vm._v("VLADIMIR")]), _vm._v(", Part I")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/16_chapter6#ch6",
      "id": "ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Victor Yushchenko, the Ukrainian Patient, Kiev, September 2004")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/17_chapter7#ch7",
      "id": "ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Béla Lapusnyik, the victim, Vienna, May 1962")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter8#ch8",
      "id": "ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nikolai Artamonov, the triple agent, Vienna, December 1975")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/19_chapter9#ch9",
      "id": "ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Litvinenko: Operation "), _c('span', {
    staticClass: "small"
  }, [_vm._v("VLADIMIR")]), _vm._v(", Part II")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/20_chapter10#ch10",
      "id": "ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nikolai Khokhlov, the illegal, Germany, 1954–7")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter11#ch11",
      "id": "ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bogdan Stashinsky, the assassin, Germany, 1957–9")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter12#ch12",
      "id": "ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Litvinenko: Operation "), _c('span', {
    staticClass: "small"
  }, [_vm._v("VLADIMIR")]), _vm._v(", Part III")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/23_chapter13#ch13",
      "id": "ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dead Souls: From Stalin to Putin")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/24_epilogue#epi",
      "id": "epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_notes#not",
      "id": "not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/26_appendix#app",
      "id": "app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Selected Soviet and Russian operations abroad: from Lenin to Litvinenko and beyond")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/27_selectbibliography#bib",
      "id": "bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/28_index#ind",
      "id": "ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f34e9a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/07_toc.vue
// module id = 72
// module chunks = 0